import { CONSTANTS } from '../api/constants'
import Dates from '../__ifunc/dates'

let initState = {
    status: '',
    error: null,
    log: [],
    totalIn: {
        total: 0,
        doors: [],
        data: []
    },
    totalOut: {
        total: 0,
        doors: [],
        data: []
    }
}

export function dashboard(state = initState, action) {
    //console.log(action)
    // let __state = { ...state }
    switch (action.type) {
        case CONSTANTS.DASHBOARD.DATA:
            // console.log(action.payload)
            for (let i = 0; i < action.payload.log.length; i++) {
                action.payload.log[i].timestamp = Dates.format(action.payload.log[i].timestamp, Dates.DTF.DATETIME)
            }

            state = {
                ...state, ...action.payload
            }
            return state
        case CONSTANTS.CLEAR:
            return initState
        default:
            return state
    }
}
